import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { style: {"width":"300px"} }
const _hoisted_3 = ["data-date"]
const _hoisted_4 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_6 = {
  key: 3,
  class: "centered-bubble-info user-select-none"
}
const _hoisted_7 = { key: 4 }
const _hoisted_8 = ["innerHTML"]

import {computed, getCurrentInstance, nextTick, onBeforeUnmount, ref, watch} from 'vue';
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatHistoryMessage from "~/core-ui/vue/chat/CoreUiChatHistoryMessage.vue";
import DateHelper from "~/ts/library/Date";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import Events from "~/ts/library/Events";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import Dictionary from "~/ts/library/Dictionary";
import {__} from "~/ts/library/Translate";
import CoreUiChatHistoryNotification from "~/core-ui/vue/chat/CoreUiChatHistoryNotification.vue";
import {CLIENT_STATUS_OFFLINE} from '~/operatorApplication/ts/data/ClientStatus';
import Delay from "~/ts/library/Delay";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import CoreUiDialogStatisticDialog from "~/core-ui/vue/chat/CoreUiDialogStatisticDialog.vue";
import CoreUiChatHistoryExposeInterface, {
    MessageNavigatorPayloadInterface
} from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import ContextMenu from "~/core-ui/vue/ui/context-menu/ContextMenu.vue";
import {ContextMenuExposeInterface, ContextMenuItemInterface} from "~/core-ui/vue/ui/context-menu/ContextMenuInterface";
import CoreUiChatHistoryMessageExposeInterface from "~/core-ui/vue/chat/CoreUiChatHistoryMessageExposeInterface";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {copyToClipboard, copyToClipboardWithNotification} from "~/ts/library/CopyToClipboard";
import CoreUiChatMessageInfoDialog from "~/core-ui/vue/chat/CoreUiChatMessageInfoDialog.vue";
import Tags from "~/cabinet/vue/interface/data/Tags.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import CoreUiChatHistoryMessageNavigator from "~/core-ui/vue/chat/CoreUiChatHistoryMessageNavigator.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import WindowHelper from "~/ts/library/WindowHelper";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import CoreUiChatHistoryMessageStatusPopover from "~/core-ui/vue/chat/CoreUiChatHistoryMessageStatusPopover.vue";
import {useRawComponent} from "~/core-ui/ts/useRawComponent";
import VueIntersect from "~/core-ui/vue/VueIntersect.vue";
import CoreUiChatHistoryMessageReactionHistoryPopover
    from "~/core-ui/vue/chat/CoreUiChatHistoryMessageReactionHistoryPopover.vue";
import MyTreeSelect from "~/core-ui/vue/ui/tree-select/MyTreeSelect.vue";
import {
    questionCategoriesToTreeData
} from "~/operatorApplication/ts/service/dialog/siteQuestionCategoriesToTreeData";
import CoreUiChatHistorySuggestedAnswer from "~/core-ui/vue/chat/CoreUiChatHistorySuggestedAnswer.vue";
import createMockMessage from "~/core-ui/vue/chat/createMockMessage";

//Никаких зависимостей кабинета или приложения оператора!!! Универсальный компонент
import OperatorApplicationMessageOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
import MessageReactionForSiteOpenApiModel = OperatorApplicationApi.MessageReactionForSiteOpenApiModel;
import OperatorGetParamsQuestionCategoryOpenApiModel = OperatorApplicationApi.OperatorGetParamsQuestionCategoryOpenApiModel;
interface DialogWithMessagesInterface {
    key: string | number,
    dialog?: OperatorApplicationApi.OperatorApplicationMessageDialogOpenApiModel,
    messages: MessageInDialogInterface[]
}

interface MessageInDialogInterface {
    current: OperatorApplicationMessageOpenApiModel,
    previous?: OperatorApplicationMessageOpenApiModel,
    previousInDialog?: OperatorApplicationMessageOpenApiModel,
    nextInDialog?: OperatorApplicationMessageOpenApiModel,
    next?: OperatorApplicationMessageOpenApiModel,
    index: number
}


import {defineComponent} from "vue";

const __default__ = defineComponent({
    name: "CoreUiChatHistory"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    messages: {},
    firstUnreadedMessageIdForNotification: {},
    shortMessageMargin: { type: Boolean },
    operators: {},
    virtualOperators: {},
    you: {},
    client: {},
    dateTop: { default: "0px" },
    messageActions: {},
    siteQuestionCategories: { default: () => ([] as OperatorGetParamsQuestionCategoryOpenApiModel[]) },
    dialogTags: { default: () => ([] as OperatorApplicationApi.OperatorGetParamsTagOpenApiModel[]) },
    messageTags: {},
    showSeconds: { type: Boolean, default: true },
    operatorMessageBackground: {},
    clientMessageBackground: {},
    selectedMessages: {},
    htmlify: {},
    operatorApplicationPlatform: {},
    clientTyping: {},
    operatorTyping: {},
    showOperatorLogins: { type: Boolean, default: true },
    showClientGoneOfflineNotification: { type: Boolean },
    utc: { type: Boolean, default: false },
    customOperatorStatusDictionary: {},
    messageSourceTypeDictionary: { default: () => ({}) },
    delayedMessages: {},
    notifications: {},
    showHistoryNotification: { type: Boolean, default: true },
    stickyAllowed: { type: Boolean, default: false },
    stickyAlways: { type: Boolean },
    showDialogInfo: { type: Boolean, default: false },
    showMessageStatus: { type: Boolean },
    scrollContainer: {},
    inCabinet: { type: Boolean },
    hasBackgroundImage: { type: Boolean },
    showOperatorGroup: { type: Boolean },
    isTranslateEnabled: { type: Boolean },
    loadDelayedMessagesListening: { type: Boolean },
    loadNotificationsListening: { type: Boolean },
    messageReactions: {},
    stickyTimeout: { default: 2000 },
    showAnsweredNotInTimeMessages: { type: Boolean },
    hideSystemMessages: { type: Boolean },
    showSuggestedAnswers: { type: Boolean },
    showSuggestedAnswersButtons: { type: Boolean }
  },
  emits: ["has-delayed-messages-changed", "update:selected-messages", "message-height-change", "update:notifications", "load-notifications", "update:delayedMessages", "load-delayed-messages"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let contextMenuRef = ref<ContextMenuExposeInterface>();
let selectionStarted = ref(false);
let selectionChanged = ref(false);
let selectedMessageIds = ref<number[]>([]);
let selectionStartMessage = ref<OperatorApplicationMessageOpenApiModel>();
let selectMode = ref<"select" | "deselect">("select");
let selectionStopMessage = ref<OperatorApplicationMessageOpenApiModel>();
let isStickyDate = ref(false);
let prevScrollValue = 0;
let selectQuestionCategoryDialog = ref<{
    visible: boolean,
    message: OperatorApplicationMessageOpenApiModel,
    model: string,
    filter: string
}>();
let selectDialogTagsDialog = ref<{
    visible: boolean,
    message: OperatorApplicationMessageOpenApiModel
}>();
let selectMessageTagsDialog = ref<{
    visible: boolean,
    message: OperatorApplicationMessageOpenApiModel
}>();
let dialogStatisticDialog = ref<{
    visible: boolean,
    dialogId: number,
    result: OperatorApplicationApi.OperatorGetDialogStatisticResultOpenApiModel
}>();


function onScroll(newValue: number) {
    if (newValue > prevScrollValue) {
        if (isStickyDate.value) {
            isStickyDate.value = false;
        }
    } else {
        setStickyTimeout(prevScrollValue - newValue > 10);
    }
    prevScrollValue = newValue;
}

async function setStickyTimeout(makeVisible: boolean = false) {
    if (makeVisible) {
        if (!isStickyDate.value) {
            isStickyDate.value = true;
        }
    }
    if (isStickyDate.value) {
        try {
            await Delay.make(props.stickyTimeout, `sticky-date-${props.client.username}`, true);
            if (isStickyDate.value) {
                isStickyDate.value = false
            }
        } catch (e) {

        }
    }
}

let startDialogTop = computed(() => {
    return `calc(${props.dateTop} + 3.55em)`;
});

let operatorsDictionary = computed<Dictionary<OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel>>(() => {
    if (props.operators) {
        return ObjectHelper.dictionaryFromArray(props.operators, "login");
    } else {
        return {};
    }
});

let virtualOperatorsDictionary = computed<Dictionary<OperatorApplicationApi.OperatorGetParamsSiteVirtualOperatorOpenApiModel>>(() => {
    if (props.virtualOperators) {
        return ObjectHelper.dictionaryFromArray(props.virtualOperators, "id");
    } else {
        return {};
    }
});


let showHasDelayedMessages = computed(() => {
    return props.client && props.client.hasDelayedMessages && props.messages;
});

let showNotifications = computed(() => {
    return props.client && props.client.hasNotifications && props.messages;
});

watch(showHasDelayedMessages, () => {
    emits("has-delayed-messages-changed");
});

let clientGoneOfflineText = computed(() => {
    if (computedMessagesByDialogs.value.length) {
        if (props.showClientGoneOfflineNotification && props.client && props.client.status == CLIENT_STATUS_OFFLINE) {
            if (!props.client.integration) {
                let visitStatistic = props.client.visitStatistic;
                if (visitStatistic && visitStatistic.lastVisitStopDateTime) {
                    let dt = (new DateHelper(visitStatistic.lastVisitStopDateTime)).toLocaleDateTimeString();
                    return `Посетитель последний раз был на сайте ${dt}`;
                }
            }
        }
    }
    return null;
});


function getTypingMessage(text: string, operatorLogin: string, isSendByClient: boolean): OperatorApplicationMessageOpenApiModel {
    let message = createMockMessage(props.client);
    let dialog = props.messages.length ? props.messages[props.messages.length - 1].dialog : null;

    message.dialog = dialog;
    message.dialogId = dialog?.id;
    message.content.text = message.text = text;
    message.operatorLogin = operatorLogin;
    message.isSendByClient = isSendByClient;
    (message as any).typing = true;
    return message;
}

let computedMessagesByDialogs = computed(() => {
    let result: DialogWithMessagesInterface[] = [];
    let lastDialog: DialogWithMessagesInterface;

    let messages = [...props.messages].sort((a, b) => {
        let result = a.id < b.id ? -1 : 1;
        if (a.id > 0 && b.id > 0 && typeof a.id == "number" && typeof b.id == "number" && Number.isInteger(a.id) && Number.isInteger(b.id)) {
            return result;
        }
        if (a.dateTime != b.dateTime) {
            result = a.dateTime < b.dateTime ? -1 : 1;
        }
        return result;
    });
    if (props.hideSystemMessages) {
        messages = messages.filter(message => {
            return !message.isShowLikeSystemInfo;
        });
    }
    if (props.you) {
        let typingMessages: OperatorApplicationMessageOpenApiModel[] = [];
        if (props.operatorTyping) {
            for (let login in props.operatorTyping) {
                if (props.operatorTyping.hasOwnProperty(login)) {
                    let text = CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.client) ? __("Печатает") + "..." : props.operatorTyping[login];
                    typingMessages.push(
                        getTypingMessage(text, login, false)
                    );
                }
            }
        }
        if (props.clientTyping) {
            typingMessages.push(getTypingMessage(props.clientTyping, props.you.login, true));
        }

        if (typingMessages.length) {
            onHeightChange();
            messages = [
                ...messages,
                ...typingMessages
            ];
        }
    }

    for (let i = 0; i < messages.length; i++) {
        let message = messages[i];
        let addNewDialog = !lastDialog || (message.dialog?.id && lastDialog.dialog?.id != message.dialog?.id);
        if (addNewDialog || !lastDialog) {
            lastDialog = {
                key: message.dialog?.id ?? message.id,
                dialog: message.dialog,
                messages: []
            };
            result.push(lastDialog);
        } else {
            lastDialog.messages[lastDialog.messages.length - 1].nextInDialog = message;
        }
        lastDialog.messages.push({
            current: message,
            previous: messages[i - 1],
            previousInDialog: lastDialog.messages[lastDialog.messages.length - 1]?.current,
            next: messages[i + 1],
            nextInDialog: null,
            index: i
        });
    }
    return result;
});

function getDateStringByMessage(message: OperatorApplicationMessageOpenApiModel) {
    return (new DateHelper(message.dateTime, props.utc)).toLocaleDateString();
}

function getDate(
    message: OperatorApplicationMessageOpenApiModel,
    previousMessage: OperatorApplicationMessageOpenApiModel
) {
    let show: boolean;
    let currentDate = getDateStringByMessage(message);
    if (previousMessage) {
        show = getDateStringByMessage(previousMessage) != currentDate;
    } else {
        show = true;
    }
    return show ? currentDate : null;
}

function getOperatorChangeReasonDescr(
    message: OperatorApplicationMessageOpenApiModel,
    previousMessage: OperatorApplicationMessageOpenApiModel
) {
    if (props.showHistoryNotification) {
        if (message.isSendByClient) {
            if (previousMessage) {
                if (previousMessage.dialog?.id == message.dialog?.id) {
                    if (previousMessage.operatorLogin != message.operatorLogin) {
                        if (previousMessage.isRealOperator) {
                            if (message.operatorsStatus.length) {
                                let operator = props.operators.find(operator => operator.login == previousMessage.operatorLogin);
                                if (operator) {
                                    let operatorStatus = message.operatorsStatus.find(item => item.login == previousMessage.operatorLogin);
                                    let descr = operator.fio;
                                    if (!operatorStatus) {
                                        return `${descr} вышел из сети`;
                                    } else if (operatorStatus.isUnavailableBecauseOfLicenseLimits) {
                                        return `${descr} стал недоступен из-за ограничений лицензии`;
                                    } else if (!operatorStatus.isVisibleForClient) {
                                        return `${descr} стал невидим для клиента`;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return null;

}

async function openDialogStatistic(dialogId?: number) {
    if (props.messageActions?.getDialogStatistic && dialogId) {
        let result = await props.messageActions?.getDialogStatistic(dialogId);
        if (result) {
            dialogStatisticDialog.value = {
                visible: true,
                result,
                dialogId
            }
        }
    }
}

let filteredQuestionCategories = computed(() => {
    let result = props.siteQuestionCategories;
    let filter = selectQuestionCategoryDialog.value.filter?.toLowerCase();
    if (filter) {
        return result.filter(item => item.value.toLowerCase().indexOf(filter) > -1);
    }
    return result;
})

let isQuestionCategorySelectAvailable = computed(() => {
    return props.siteQuestionCategories.length > 0 && !!props.messageActions?.questionCategoryChange;
});

let isDialogTagsSelectAvailable = computed(() => {
    return props.dialogTags.length > 0 && !!props.messageActions?.dialogTagsChange;
});

function showQuestionCategorySelect(message: OperatorApplicationMessageOpenApiModel) {
    selectQuestionCategoryDialog.value = {
        visible: true,
        message,
        filter: null,
        model: message.dialog?.questionCategory
    };
}

function onQuestionCategorySelect(newValue?: string) {
    props.messageActions.questionCategoryChange(selectQuestionCategoryDialog.value.message, newValue);
    selectQuestionCategoryDialog.value = null;
}

function showDialogTagsSelect(message: OperatorApplicationMessageOpenApiModel) {
    if (props.messageActions?.dialogTagsChange) {
        selectDialogTagsDialog.value = {
            visible: true,
            message: ObjectHelper.jsonClone(message),
        };
    }
}

function applyDialogTags() {
    let message = selectDialogTagsDialog.value.message;
    props.messageActions.dialogTagsChange(message, message.dialog.tags);
    selectDialogTagsDialog.value = null;
}

function showMessageTagsSelect(message: OperatorApplicationMessageOpenApiModel) {
    selectMessageTagsDialog.value = {
        visible: true,
        message: ObjectHelper.jsonClone(message),
    };
}

function applyMessageTags() {
    let message = selectMessageTagsDialog.value.message;
    props.messageActions.messageTagsChange(message, message.tags);
    selectMessageTagsDialog.value = null;
}

function isFirstMessageOfDialog(dialog: DialogWithMessagesInterface, message: OperatorApplicationMessageOpenApiModel, index: number) {
    if (!dialog.dialog) {
        return false;
    }
    let isFirstMessage = !!message.dialog;
    if (isFirstMessage) {
        for (let i = index - 1; i >= 0; i--) {
            let prevMessage = dialog.messages[i];
            if (prevMessage.current.dialog) {
                isFirstMessage = false;
                break;
            }
        }
    }
    return isFirstMessage;
}

function isLastMessageOfDialog(dialog: DialogWithMessagesInterface) {
    let result = false;

    if (dialog.dialog && props.client) {
        result = dialog.dialog.id != getCurrentDialogOfClient(props.client)?.id;
    }
    return result;
}

async function onEdit(message: OperatorApplicationMessageOpenApiModel) {
    if (props.messageActions?.edit) {
        let result = await props.messageActions.edit(message);
        if (typeof result == "object" && result.id == message.id) {
            let index = props.messages.findIndex(item => item.id === message.id);
            if (index > -1) {
                props.messages[index] = result;
            }
        }
    }
}

async function onRemove(message: OperatorApplicationMessageOpenApiModel) {
    if (props.messageActions?.remove) {
        let result = await props.messageActions.remove(message);
        if (result) {
            let index = props.messages.findIndex(item => item.id === message.id);
            if (index > -1) {
                props.messages.splice(index, 1);
            }
        }
    }
}

function isMessageSelected(message: OperatorApplicationMessageOpenApiModel) {
    return selectedMessageIds.value.indexOf(message.id) > -1;
}

let selectable = computed(() => {
    return Array.isArray(props.selectedMessages);
});

function onMouseDown() {
    if (selectable.value) {
        selectionStarted.value = true;
        selectionChanged.value = false;
    }
}

function onMouseUp() {
    selectionStarted.value = false;
    if (selectionChanged.value) {
        selectionChanged.value = false;
        clearSelection();
    }
    document.body.classList.remove("user-select-none");
}

function clearSelection() {
    if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
            window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
            window.getSelection().removeAllRanges();
        }
    }
}

function sortIndexes(start: number, stop: number) {
    return [start, stop].sort((a, b) => {
        return a > b ? 1 : -1;
    });
}

function getMessageIndex(message: OperatorApplicationMessageOpenApiModel, defaultValue: number) {
    let result = props.messages.findIndex(item => item.id === message.id);
    return result < 0 ? defaultValue : result;
}

function onMouseEnter(message: OperatorApplicationMessageOpenApiModel) {
    let messageIndex = getMessageIndex(message, -1);
    if (messageIndex > -1) {
        if (selectionStarted.value && selectionStartMessage.value) {
            let selectionStartMessageIndex = getMessageIndex(selectionStartMessage.value, messageIndex);

            let indexes = sortIndexes(messageIndex, selectionStartMessageIndex);
            for (let i = indexes[0]; i <= indexes[1]; i++) {
                toggleSelectedMessage(props.messages[i], selectMode.value == "select");
            }
            let selectionStopMessageIndex = getMessageIndex(selectionStopMessage.value, messageIndex);
            let previousIndexes = sortIndexes(selectionStartMessageIndex, selectionStopMessageIndex);
            for (let i = previousIndexes[0]; i <= previousIndexes[1]; i++) {
                if (i < indexes[0] || i > indexes[1]) {
                    toggleSelectedMessage(props.messages[i], selectMode.value != "select");
                }
            }
        } else {
            selectMode.value = isMessageSelected(message) ? "deselect" : "select";
            selectionStartMessage.value = message;
        }
        selectionStopMessage.value = message;
    }

}

function toggleSelectedMessage(message: OperatorApplicationMessageOpenApiModel, value: boolean = null) {
    if (selectable.value) {
        let id = message.id;
        if (id) {
            if (typeof value != "boolean") {
                value = !isMessageSelected(message);
            }
            if (toggleArrayElement(selectedMessageIds.value, id, value)) {
                selectionChanged.value = true;
                if (selectionStarted.value) {
                    document.body.classList.add("user-select-none");
                }
            }
        }
    }
}

let instance = getCurrentInstance().proxy;

let contextMenuMessage = ref<OperatorApplicationMessageOpenApiModel>();
let messageReactionsPopoverVisible = ref(false);


function openContextMenu(event: MouseEvent, menu: ContextMenuItemInterface[], message?: OperatorApplicationMessageOpenApiModel) {
    messageReactionsPopoverVisible.value = false;
    contextMenuMessage.value = message;
    nextTick(() => {
        contextMenuRef.value.openMenu(event, menu);
    });
}

function openDialogContextMenu(dialog: DialogWithMessagesInterface, event: MouseEvent) {
    let dialogId = dialog?.dialog.id;
    if (dialogId) {
        let menu: ContextMenuItemInterface[] = [];

        let preventDefault = true;

        if (window.getSelection) {
            let selectedText = window.getSelection().toString();
            if (selectedText.length) {
                menu.push({
                    text: "Копировать выделенный текст",
                    icon: "copy",
                    onClick: () => copyToClipboard(selectedText)
                });
                if (props.operatorApplicationPlatform) {
                    preventDefault = props.operatorApplicationPlatform?.isPreventContextMenuWithSelectionInChatHistory(true);
                }
            }
        }
        if (preventDefault) {
            event.preventDefault();

            if (props.messageActions?.otherDialogActions) {
                for (let action of props.messageActions.otherDialogActions) {
                    (function (action) {
                        menu.push({
                            text: action.descr,
                            icon: action.icon,
                            onClick: () => {
                                action.callback([dialogId])
                            }
                        })
                    })(action);
                }
            }
        }
        openContextMenu(event, menu);
    }
}

function openMessageContextMenu(message: OperatorApplicationMessageOpenApiModel, event: MouseEvent) {
    let menu: ContextMenuItemInterface[] = [];

    let preventDefault = true;
    if ((event.target as HTMLElement).tagName === "VIDEO") {
        if (props.operatorApplicationPlatform) {
            preventDefault = props.operatorApplicationPlatform?.isPreventContextMenuWithSelectionInChatHistory(true);
        }
    }

    let selectedText: string;
    if (window.getSelection) {
        selectedText = window.getSelection().toString();
        if (selectedText.length) {
            menu.push({
                text: "Копировать выделенный текст",
                icon: "copy",
                onClick: () => copyToClipboard(selectedText)
            });
            if (preventDefault) {
                if (props.operatorApplicationPlatform) {
                    preventDefault = props.operatorApplicationPlatform?.isPreventContextMenuWithSelectionInChatHistory(true);
                }
            }
        }
    }

    if (preventDefault) {
        event.preventDefault();

        for (let pathElement of event.composedPath()) {
            try {
                let element: HTMLElement = pathElement as HTMLElement;
                let url = element.getAttribute("data-attachment-url");
                if (url) {
                    menu.push({
                        text: __("Скопировать ссылку"),
                        onClick: () => {
                            copyToClipboard(url);
                        },
                        icon: "link"
                    });
                    break;
                }
            } catch (e) {

            }
        }

        let messageActions = props.messageActions;
        if (messageActions) {
            if (props.selectedMessages?.length) {
                if (messageActions.copy) {
                    menu.push({
                        text: __('Скопировать выделенные сообщения'),
                        onClick: () => messageActions.copy(),
                        icon: "copy"
                    });
                }
                if (messageActions.translateMessages) {
                    let messagesForTranslations = props.selectedMessages.filter(message => Number.isInteger(message.id));
                    if (messagesForTranslations.length > 0) {
                        if (Number.isInteger(message.id)) {
                            menu.push({
                                text: __('Перевод'),
                                onClick: async () => {
                                    CoreUiChatHistoryHelper.translateMessages(messageActions.translateMessages, messagesForTranslations);
                                    clearSelectedMessages();
                                },
                                icon: "language"
                            });
                        }
                    }
                }
                if (messageActions.otherMessagesActions) {
                    for (let action of messageActions.otherMessagesActions) {
                        (function (action) {
                            menu.push({
                                text: action.descr,
                                icon: action.icon,
                                onClick: () => {
                                    action.callback(props.selectedMessages)
                                }
                            })
                        })(action);

                    }
                }
                menu.push({
                    text: __("Отменить выбор"),
                    onClick: () => clearSelectedMessages(),
                    icon: "check-circle"
                })
            } else {
                if (messageActions.reply) {
                    if (message.isAnswerable) {
                        menu.push({
                            text: __("Ответить"),
                            onClick: () => messageActions.reply(message),
                            icon: "reply"
                        });
                    }
                }
                if (messageActions.pin && message.isPinable) {
                    menu.push({
                        text: message.isPinned ? __("Открепить") : __("Закрепить"),
                        onClick: () => messageActions.pin(message),
                        icon: message.isPinned ? "thumbtack-slash" : "thumbtack",
                    })
                }
                if (messageActions.edit && message.isEditable) {
                    menu.push({
                        text: __("Редактировать"),
                        onClick: () => onEdit(message),
                        icon: "pencil"
                    });
                }
                if (messageActions.remove && message.isRemovable) {
                    menu.push({
                        text: __("Удалить"),
                        onClick: () => onRemove(message),
                        icon: "times"
                    });
                }
                if (messageActions.copy) {
                    menu.push({
                        text: __('Скопировать сообщение'),
                        onClick: () => messageActions.copy(message),
                        icon: "copy"
                    });
                }
                if (message.linkToApplication) {
                    menu.push({
                        text: __('Скопировать ссылку на сообщение'),
                        onClick: () => {
                            copyToClipboardWithNotification(message.linkToApplication);
                        },
                        icon: "link"
                    });
                }
                if (messageActions.addToTemplates) {
                    if (!message.isSendByClient) {
                        menu.push({
                            text: __('Добавить шаблон'),
                            onClick: () => messageActions.addToTemplates(message),
                            icon: "bolt"
                        });
                    }
                }
                if (messageActions.sendToRates) {
                    if (message.isSendByClient) {
                        menu.push({
                            text: __('Отправить в отзывы'),
                            onClick: () => messageActions.sendToRates(message),
                            icon: "star"
                        });
                    }
                }
                let ref: CoreUiChatHistoryMessageExposeInterface[] = instance.$refs[`message_${message.id}`] as any;
                if (Array.isArray(ref) && ref[0]) {
                    if (ref[0].isDownloadAvailable()) {
                        menu.push({
                            text: __('Скачать вложения'),
                            onClick: () => ref[0].download(),
                            icon: "download"
                        });
                    }
                }
                if (messageActions.messageTagsChange && props.messageTags.length && message.id) {
                    if (!message.messageType || message.messageType?.isCanHaveTags) {
                        menu.push({
                            text: __('Изменить тэги'),
                            onClick: () => showMessageTagsSelect(message),
                            icon: "tags"
                        });
                    }
                }
                if (message.senderInfo.ip || message.senderInfo.useragent || message.senderInfo.page || message.operatorsStatus.length || message.source) {
                    menu.push({
                        text: __('Информация'),
                        onClick: () => {
                            messageInfoDialog.value = {
                                visible: true,
                                message
                            }
                        },
                        icon: "info-circle"
                    });
                }
                if (message.cascadeMessageId && props.messageActions?.openCascadeMessageReport) {
                    menu.push({
                        text: "Отчёт по сценарию",
                        onClick: () => {
                            props.messageActions.openCascadeMessageReport(message.cascadeMessageId);
                        },
                        icon: "share-alt"
                    });
                }
                if (messageActions.otherMessagesActions) {
                    for (let action of messageActions.otherMessagesActions) {
                        (function (action) {
                            menu.push({
                                text: action.descr,
                                icon: action.icon,
                                onClick: () => {
                                    if (selectedText && selectedText.length) {
                                        action.callback([], selectedText);
                                    } else {
                                        action.callback([message])
                                    }
                                }
                            })
                        })(action);

                    }
                }
                if (messageActions.translateMessages) {
                    if (Number.isInteger(message.id)) {
                        menu.push({
                            text: __('Перевод'),
                            onClick: async () => {
                                CoreUiChatHistoryHelper.translateMessages(messageActions.translateMessages, [message]);
                            },
                            icon: "language"
                        });
                    }
                }
                if (!message.messageType?.isAutoMessage && message.id) {
                    menu.push({
                        text: __("Статус"),
                        icon: "check-double",
                        popover: {
                            component: useRawComponent(CoreUiChatHistoryMessageStatusPopover),
                            props: {
                                messageId: message.id,
                                operators: props.operators ?? [],
                                showOperatorLogins: !!props.showOperatorLogins,
                                client: props.client
                            },
                            popperClass: 'p-0 max-height-100'
                        }
                    })
                }
                menu.push({
                    text: __("История реакций"),
                    icon: "face-smile",
                    popover: {
                        component: useRawComponent(CoreUiChatHistoryMessageReactionHistoryPopover),
                        props: {
                            message: message,
                            operators: props.operators ?? [],
                            showOperatorLogins: !!props.showOperatorLogins,
                            client: props.client
                        },
                        popperClass: 'p-0 max-height-100'
                    }
                });
            }
        }

        openContextMenu(event, menu, message);
    }
}

let messageInfoDialog = ref<{
    visible: boolean,
    message: OperatorApplicationMessageOpenApiModel
}>();

watch(selectedMessageIds, () => {
    let messages = props.messages.filter(message => selectedMessageIds.value.indexOf(message.id) > -1);
    emits("update:selected-messages", messages);
}, {deep: true});

function clearSelectedMessages() {
    selectedMessageIds.value.splice(0, selectedMessageIds.value.length);
}

function onHeightChange() {
    emits("message-height-change");
    if (lastScrollToMessageById) {
        scrollToMessageById(lastScrollToMessageById, false);
    }
}

setStickyTimeout(true);
addDisposableEvent(Events.addEventListener("mouseup", window, () => {
    onMouseUp();
}));

let messageNavigator = ref<MessageNavigatorPayloadInterface>();

function showMessageNavigator(payload: MessageNavigatorPayloadInterface) {
    if (props.messageActions?.fetchMessagesFromId && props.scrollContainer) {
        messageNavigator.value = payload;
    } else {
        console.warn("Нельзя использовать навигатор, недостаточно параметров");
    }
}

async function fetchAndMoveToMessageById(id: number) {
    let container = props.scrollContainer;
    if (container) {
        if (!props.messages.find(item => item.id == id)) {
            if (props.messageActions?.fetchMessagesFromId) {
                await props.messageActions.fetchMessagesFromId(id);
            }
        }
        scrollToMessageById(id);
    }
}

let lastScrollToMessageById: number;

async function scrollToMessageById(id: number, animate: boolean = true) {
    let container = props.scrollContainer;
    if (container) {
        lastScrollToMessageById = id;
        nextTick(async () => {
            let message = props.messages.find(item => item.id == id);
            if (message) {
                let selector = CoreUiChatHistoryHelper.getMessageSelector(message);
                const className = "highlight";
                if (animate) {
                    instance.$el.querySelectorAll(`.${className}.chat-history-message`).forEach((element: HTMLElement) => {
                        element.classList.remove(className)
                    });
                }
                let element: HTMLElement = instance.$el.querySelector(selector);

                if (element) {
                    WindowHelper.scrollToElement(element, container, animate ? 200 : 0, (container.offsetTop * -1) - container.offsetHeight / 2);

                    if (animate) {
                        element.classList.add(className);
                        try {
                            await Delay.make(1500, `highlightMessage_${message.id}`, true);
                            element.classList.remove(className);
                        } catch (e) {

                        }
                    }
                }
            }
            await Delay.make(2000);
            if (lastScrollToMessageById === id) {
                lastScrollToMessageById = undefined;
            }
        });

    }
}

async function setMessageReaction(message: OperatorApplicationMessageOpenApiModel, emoji: string) {
    let copy = ObjectHelper.jsonClone(message.reactions);
    if (props.you) {
        let reaction = message.reactions.find(reaction => reaction.operatorLogin === props.you.login);
        if (reaction) {
            reaction.emoji = emoji;
        } else {
            message.reactions.push({
                operatorLogin: props.you.login,
                isFromClient: false,
                emoji: emoji,
                isFromOperator: true,
                dateTime: (new DateHelper(new Date())).toMysqlFormat(),
                timestamp: Math.ceil(Date.now() / 1000)
            });
        }
    }
    let result = await props.messageActions.setMessageReaction(message, emoji);
    if (!result) {
        message.reactions = copy;
    }
}

let intersectionObserver = ref<IntersectionObserver>(new IntersectionObserver((entries) => {
        for (let entry of entries) {
            if (entry.isIntersecting) {
                entry.target.classList.add("intersect");
            } else {
                entry.target.classList.remove("intersect");
            }
        }
    }, {
        threshold: 0.000001,
        root: props.scrollContainer,
    })
);

let isSticky = computed(() => {
    return !!props.stickyAlways || (isStickyDate.value && !!props.stickyAllowed);
})

onBeforeUnmount(() => {
    intersectionObserver.value.disconnect();
    intersectionObserver.value = null;
});


__expose<CoreUiChatHistoryExposeInterface>({
    clearSelectedMessages,
    onScroll,
    showMessageNavigator,
    scrollToMessageById
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_core_ui_chat_history = _resolveComponent("core-ui-chat-history", true)!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    onMousedownPassive: _withModifiers(onMouseDown, ["left"]),
    onMouseupPassive: _withModifiers(onMouseUp, ["left"]),
    class: _normalizeClass({
            'core-ui-chat-history': true,
            'fade': __props.messages.length == 0
        })
  }, [
    (_unref(messageNavigator))
      ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageNavigator, {
          key: _unref(messageNavigator).key,
          payload: _unref(messageNavigator),
          "onUpdate:payload": _cache[0] || (_cache[0] = ($event: any) => (_isRef(messageNavigator) ? (messageNavigator).value = $event : messageNavigator = $event)),
          onMoveTo: fetchAndMoveToMessageById
        }, null, 8, ["payload"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(ContextMenu, {
      ref_key: "contextMenuRef",
      ref: contextMenuRef,
      key: _unref(contextMenuMessage)?.id
    }, {
      default: _withCtx(() => [
        (_unref(contextMenuMessage)?.isReactionAvailable && __props.messageReactions && __props.messageReactions.length && __props.messageActions?.setMessageReaction)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messageReactions.slice(0, 6), (reaction) => {
                return (_openBlock(), _createBlock(_component_el_button, {
                  key: reaction.emoji,
                  circle: "",
                  class: "reaction-button",
                  plain: "",
                  type: "primary",
                  onClick: ($event: any) => (setMessageReaction(_unref(contextMenuMessage), reaction.emoji))
                }, {
                  default: _withCtx(() => [
                    _createVNode(CoreUiHtmlify, {
                      value: reaction.emoji,
                      emoji: "",
                      style: {"font-size":".8em"}
                    }, null, 8, ["value"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              (__props.messageReactions.length > 6)
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 0,
                    visible: _unref(messageReactionsPopoverVisible),
                    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(messageReactionsPopoverVisible) ? (messageReactionsPopoverVisible).value = $event : messageReactionsPopoverVisible = $event)),
                    teleported: false,
                    "popper-class": "reaction-popper"
                  }, {
                    reference: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                        circle: "",
                        class: "reaction-button",
                        plain: "",
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(messageReactionsPopoverVisible) //@ts-ignore
 ? messageReactionsPopoverVisible.value = !_unref(messageReactionsPopoverVisible) : messageReactionsPopoverVisible = !_unref(messageReactionsPopoverVisible)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(FontAwesomeIcon, { icon: "chevron-down" })
                        ]),
                        _: 1
                      })), [
                        [
                          _directive_on_native,
                          void 0,
                          "click",
                          {
                            stop: true,
                            stopImmediate: true
                          }
                        ]
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messageReactions, (reaction) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            key: reaction.emoji,
                            circle: "",
                            class: "reaction-button",
                            plain: "",
                            type: "primary",
                            onClick: ($event: any) => (setMessageReaction(_unref(contextMenuMessage), reaction.emoji))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CoreUiHtmlify, {
                                value: reaction.emoji,
                                emoji: "",
                                style: {"font-size":".8em"}
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _renderSlot(_ctx.$slots, "before"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedMessagesByDialogs), (dialog) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
          class: _normalizeClass(`dialog will-change-transform dialog-${dialog.dialog ? dialog.dialog.id : ''}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialog.messages, (dialogMessage, indexInDialog) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: dialogMessage.current.id ? dialogMessage.current.id : dialogMessage.current.temporaryId
            }, [
              (getDate(dialogMessage.current, dialogMessage.previousInDialog))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
                            '-top centered-bubble-info date': true,
                             'sticky': _unref(isSticky),
                            'with-shadow': (!dialogMessage.previousInDialog) || !__props.stickyAllowed,
                            'user-select-none' : _unref(selectable)
                        }),
                    "data-date": getDateStringByMessage(dialogMessage.current),
                    style: _normalizeStyle({top: __props.dateTop})
                  }, [
                    _createElementVNode("span", null, _toDisplayString(getDate(dialogMessage.current, dialogMessage.previousInDialog)), 1),
                    (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" .dialog-" + _toDisplayString(dialog.dialog?.id) + ":not(:has(.message.intersect[data-date='" + _toDisplayString(getDateStringByMessage(dialogMessage.current)) + "'])) .date[data-date='" + _toDisplayString(getDateStringByMessage(dialogMessage.current)) + "'] { position: relative !important; } ", 1)
                      ]),
                      _: 2
                    }, 1024))
                  ], 14, _hoisted_3))
                : _createCommentVNode("", true),
              (__props.showDialogInfo && __props.showHistoryNotification && _unref(props).client && _unref(props).client.type.isReal)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (isFirstMessageOfDialog(dialog, dialogMessage.current, indexInDialog) && dialogMessage.current.dialog)
                      ? _withDirectives((_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
                          key: 0,
                          text: "",
                          class: _normalizeClass({
                            'sticky': _unref(isSticky),
                            'dialog-start': true,
                            'with-shadow': true
                        }),
                          style: _normalizeStyle({top: _unref(startDialogTop)})
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createTextVNode(_toDisplayString(_unref(__)("Диалог")) + " ", 1),
                              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.messageActions && __props.messageActions.getDialogStatistic ? 'a' : 'span'), {
                                tabindex: "",
                                onClick: _withModifiers(($event: any) => (openDialogStatistic(dialog.dialog ? dialog.dialog.id : null)), ["stop"]),
                                class: _normalizeClass(__props.messageActions && __props.messageActions.getDialogStatistic ? 'link-dashed' : null),
                                textContent: _toDisplayString(`№${dialogMessage.current.dialog.id}`)
                              }, null, 8, ["onClick", "class", "textContent"]))
                            ]),
                            (_unref(isQuestionCategorySelectAvailable) || dialogMessage.current.dialog.questionCategory)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(_unref(__)('Категория вопроса')) + ": ", 1),
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isQuestionCategorySelectAvailable) ? 'a' : 'span'), {
                                      onClick: _withModifiers(($event: any) => (showQuestionCategorySelect(dialogMessage.current)), ["stop"]),
                                      tabindex: "",
                                      class: _normalizeClass(_unref(isQuestionCategorySelectAvailable) ? 'link-dashed' : null),
                                      textContent: _toDisplayString(dialogMessage.current.dialog.questionCategory ?  dialogMessage.current.dialog.questionCategory : _unref(__)('не задана'))
                                    }, null, 8, ["onClick", "class", "textContent"]))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(isDialogTagsSelectAvailable) || dialogMessage.current.dialog.tags.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(_unref(__)('Тэги диалога')) + ": ", 1),
                                    (!dialogMessage.current.dialog.tags.length)
                                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isDialogTagsSelectAvailable) ? 'a' : 'span'), {
                                          key: 0,
                                          onClick: _withModifiers(($event: any) => (showDialogTagsSelect(dialogMessage.current)), ["stop"]),
                                          tabindex: "",
                                          class: _normalizeClass(_unref(isDialogTagsSelectAvailable) ? 'link-dashed' : null),
                                          textContent: _toDisplayString(_unref(__)('не заданы'))
                                        }, null, 8, ["onClick", "class", "textContent"]))
                                      : _withDirectives((_openBlock(), _createBlock(Tags, {
                                          key: 1,
                                          tags: dialogMessage.current.dialog.tags,
                                          "possible-tags": __props.dialogTags,
                                          maximum: 3,
                                          "with-border": "",
                                          class: _normalizeClass({
                                            'cursor-pointer': _unref(isDialogTagsSelectAvailable),
                                            'd-inline-block dialog-tags': true
                                        })
                                        }, null, 8, ["tags", "possible-tags", "class"])), [
                                          [
                                            _directive_on_native,
                                            () => showDialogTagsSelect(dialogMessage.current),
                                            "click",
                                            { stop: true }
                                          ]
                                        ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class", "style"])), [
                          [_directive_on_native, (event) => openDialogContextMenu(dialog,  event), "contextmenu"]
                        ])
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (__props.firstUnreadedMessageIdForNotification === dialogMessage.current.id)
                ? (_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
                    key: 2,
                    text: "",
                    class: _normalizeClass({
                            'with-shadow': true
                        })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(__)("Непрочитанные сообщения")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (getOperatorChangeReasonDescr(dialogMessage.current, dialogMessage.previous))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(getOperatorChangeReasonDescr(dialogMessage.current, dialogMessage.previous)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(VueIntersect, { observer: _unref(intersectionObserver) }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(CoreUiChatHistoryMessage, {
                    key: "a",
                    class: "message",
                    "data-date": getDateStringByMessage(dialogMessage.current),
                    message: dialogMessage.current,
                    "previous-message": dialogMessage.previous,
                    "next-message": dialogMessage.next,
                    "operators-dictionary": _unref(operatorsDictionary),
                    "virtual-operators-dictionary": _unref(virtualOperatorsDictionary),
                    "short-margin": __props.shortMessageMargin,
                    "operator-message-background": __props.operatorMessageBackground,
                    "client-message-background": __props.clientMessageBackground,
                    "show-operator-logins": __props.showOperatorLogins,
                    you: __props.you,
                    client: __props.client,
                    ref_for: true,
                    ref: `message_${dialogMessage.current.id}`,
                    dialog: dialog.dialog,
                    "message-actions": __props.messageActions,
                    "show-seconds": __props.showSeconds,
                    "message-tags": __props.messageTags,
                    utc: __props.utc,
                    selected: isMessageSelected(dialogMessage.current),
                    "data-core-ui-chat-history-message-with-id": dialogMessage.current.id,
                    htmlify: __props.htmlify,
                    "operator-application-platform": __props.operatorApplicationPlatform,
                    "custom-operator-status-dictionary": __props.customOperatorStatusDictionary,
                    "show-dialog-info": __props.showDialogInfo,
                    "has-background-image": __props.hasBackgroundImage,
                    "show-operator-group": __props.showOperatorGroup,
                    "show-answered-not-in-time-messages": __props.showAnsweredNotInTimeMessages,
                    "short-message-margin": __props.shortMessageMargin,
                    "message-source-type": dialogMessage.current.source ? __props.messageSourceTypeDictionary[dialogMessage.current.source.typeId] : undefined,
                    onClick: ($event: any) => (toggleSelectedMessage(dialogMessage.current)),
                    onHeightChange: onHeightChange,
                    onDialogClosedClick: ($event: any) => (openDialogStatistic(dialog.dialog ? dialog.dialog.id : null))
                  }, {
                    "message-meta-start": _withCtx((slotProps) => [
                      _renderSlot(_ctx.$slots, "message-meta-start", _mergeProps({ ref_for: true }, slotProps))
                    ]),
                    _: 3
                  }, 8, ["data-date", "message", "previous-message", "next-message", "operators-dictionary", "virtual-operators-dictionary", "short-margin", "operator-message-background", "client-message-background", "show-operator-logins", "you", "client", "dialog", "message-actions", "show-seconds", "message-tags", "utc", "selected", "data-core-ui-chat-history-message-with-id", "htmlify", "operator-application-platform", "custom-operator-status-dictionary", "show-dialog-info", "has-background-image", "show-operator-group", "show-answered-not-in-time-messages", "short-message-margin", "message-source-type", "onClick", "onDialogClosedClick"])), [
                    [_directive_on_native, () => onMouseEnter(dialogMessage.current), "mouseenter"],
                    [_directive_on_native, (event) => openMessageContextMenu(dialogMessage.current, event), "contextmenu"]
                  ])
                ]),
                _: 2
              }, 1032, ["observer"]),
              (__props.showSuggestedAnswers && dialogMessage.current.suggestedAnswers?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogMessage.current.suggestedAnswers, (answer) => {
                      return (_openBlock(), _createBlock(CoreUiChatHistorySuggestedAnswer, {
                        "suggested-answer": answer,
                        client: _unref(props).client,
                        "operator-message-background": __props.operatorMessageBackground,
                        "show-seconds": __props.showSeconds,
                        "show-suggested-answers-buttons": __props.showSuggestedAnswersButtons,
                        "message-actions": __props.messageActions,
                        onOnHeightChange: onHeightChange,
                        onScrollToMessage: _cache[3] || (_cache[3] = ($event: any) => (fetchAndMoveToMessageById($event)))
                      }, null, 8, ["suggested-answer", "client", "operator-message-background", "show-seconds", "show-suggested-answers-buttons", "message-actions"]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 2),
        (__props.showDialogInfo && _unref(props).client && _unref(props).client.type.isReal && isLastMessageOfDialog(dialog))
          ? _withDirectives((_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
              key: 0,
              icon: "check-circle",
              class: "with-shadow",
              text: "",
              onClick: ($event: any) => (openDialogStatistic(dialog.dialog ? dialog.dialog.id : null))
            }, {
              default: _withCtx(() => [
                (!dialog || !dialog.dialog)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(__)("Конец диалога")), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      innerHTML: _unref(__)('Конец диалога %s', `<a tabindex='' class='link-dashed'>№${dialog.dialog.id}</a>`)
                    }, null, 8, _hoisted_8))
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_on_native, (event) => openDialogContextMenu(dialog, event), "contextmenu"]
            ])
          : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    (_unref(clientGoneOfflineText) && __props.showHistoryNotification)
      ? (_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
          key: 1,
          icon: "sign-out",
          "icon-class": "text-muted",
          text: _unref(clientGoneOfflineText)
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (__props.client && __props.client.hasDelayedMessages && __props.loadDelayedMessagesListening)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_unref(showHasDelayedMessages))
            ? (_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
                key: 0,
                class: _normalizeClass({
                    'm-0': !_unref(computedMessagesByDialogs).length
                }),
                icon: "clock",
                "icon-class": "text-orange",
                text: "Есть отложенные сообщения",
                clickable: "",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(emits)('load-delayed-messages')))
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (__props.delayedMessages && __props.delayedMessages.length)
            ? (_openBlock(), _createBlock(_component_el_card, {
                key: 1,
                class: "transparent-dashed-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_core_ui_chat_history, {
                    messages: __props.delayedMessages,
                    client: __props.client,
                    "show-dialog-info": false,
                    "show-seconds": __props.showSeconds,
                    "operator-application-platform": __props.operatorApplicationPlatform,
                    operators: __props.operators,
                    "message-actions": {
                        remove: __props.messageActions?.remove ?? undefined,
                        edit: __props.messageActions?.edit ?? undefined
                    }
                  }, null, 8, ["messages", "client", "show-seconds", "operator-application-platform", "operators", "message-actions"]),
                  _createVNode(CoreUiChatHistoryNotification, {
                    icon: "times",
                    "icon-class": "text-red",
                    text: "Закрыть отложенные сообщения",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(emits)('update:delayedMessages'))),
                    clickable: ""
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (__props.client && __props.client.hasNotifications && __props.loadNotificationsListening)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_unref(showNotifications))
            ? (_openBlock(), _createBlock(CoreUiChatHistoryNotification, {
                key: 0,
                class: _normalizeClass({
                    'm-0': !_unref(computedMessagesByDialogs).length
                }),
                icon: "bell",
                "icon-class": "text-orange",
                text: "Есть созданные напоминания",
                clickable: "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(emits)('load-notifications')))
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (__props.notifications && __props.notifications.length)
            ? (_openBlock(), _createBlock(_component_el_card, {
                key: 1,
                class: "transparent-dashed-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_core_ui_chat_history, {
                    operators: __props.operators,
                    "virtual-operators": __props.virtualOperators,
                    "show-seconds": __props.showSeconds,
                    "custom-operator-status-dictionary": __props.customOperatorStatusDictionary,
                    "show-operator-logins": __props.showOperatorLogins,
                    messages: __props.notifications,
                    client: __props.client,
                    "show-dialog-info": false,
                    "operator-application-platform": __props.operatorApplicationPlatform,
                    "message-actions": {
                        remove: __props.messageActions ? __props.messageActions.removeNotification : undefined
                    },
                    "has-background-image": __props.hasBackgroundImage
                  }, null, 8, ["operators", "virtual-operators", "show-seconds", "custom-operator-status-dictionary", "show-operator-logins", "messages", "client", "operator-application-platform", "message-actions", "has-background-image"]),
                  _createVNode(CoreUiChatHistoryNotification, {
                    icon: "times",
                    "icon-class": "text-red",
                    text: "Закрыть будущие напоминания",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(emits)('update:notifications'))),
                    clickable: ""
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "after"),
    (_unref(selectQuestionCategoryDialog) && _unref(selectQuestionCategoryDialog).visible)
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 4,
          visible: _unref(selectQuestionCategoryDialog).visible,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_unref(selectQuestionCategoryDialog).visible) = $event)),
          title: _unref(__)('Выберите категорию'),
          "button-text": _unref(__)('Сохранить'),
          "max-width": "500px",
          onApply: _cache[10] || (_cache[10] = ($event: any) => (onQuestionCategorySelect(_unref(selectQuestionCategoryDialog).model)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(MyTreeSelect, {
                modelValue: _unref(selectQuestionCategoryDialog).model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(selectQuestionCategoryDialog).model) = $event)),
                data: _unref(questionCategoriesToTreeData)(__props.siteQuestionCategories)
              }, null, 8, ["modelValue", "data"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "title", "button-text"]))
      : _createCommentVNode("", true),
    (_unref(selectDialogTagsDialog) && _unref(selectDialogTagsDialog).visible)
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 5,
          visible: _unref(selectDialogTagsDialog).visible,
          "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_unref(selectDialogTagsDialog).visible) = $event)),
          title: _unref(__)('Выберите тэги'),
          "max-width": "500px",
          onApply: applyDialogTags
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(selectDialogTagsDialog).message.dialog.tags,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(selectDialogTagsDialog).message.dialog.tags) = $event)),
              placeholder: _unref(__)('Тэги'),
              class: "w-100",
              multiple: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).dialogTags, (tag, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    value: tag.tag
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_unref(selectMessageTagsDialog) && _unref(selectMessageTagsDialog).visible)
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 6,
          visible: _unref(selectMessageTagsDialog).visible,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_unref(selectMessageTagsDialog).visible) = $event)),
          title: _unref(__)('Выберите тэги'),
          "max-width": "500px",
          onApply: applyMessageTags
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(selectMessageTagsDialog).message.tags,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(selectMessageTagsDialog).message.tags) = $event)),
              placeholder: _unref(__)('Тэги'),
              class: "w-100",
              multiple: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).messageTags, (tag, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    value: tag.tag
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    (_unref(dialogStatisticDialog) && _unref(dialogStatisticDialog).visible)
      ? (_openBlock(), _createBlock(CoreUiDialogStatisticDialog, {
          key: 7,
          "dialog-id": _unref(dialogStatisticDialog).dialogId,
          "operators-dictionary": _unref(operatorsDictionary),
          result: _unref(dialogStatisticDialog).result,
          "show-operator-logins": __props.showOperatorLogins,
          visible: _unref(dialogStatisticDialog).visible,
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_unref(dialogStatisticDialog).visible) = $event)),
          "in-cabinet": __props.inCabinet
        }, null, 8, ["dialog-id", "operators-dictionary", "result", "show-operator-logins", "visible", "in-cabinet"]))
      : _createCommentVNode("", true),
    (_unref(messageInfoDialog) && _unref(messageInfoDialog).visible)
      ? (_openBlock(), _createBlock(CoreUiChatMessageInfoDialog, {
          key: 8,
          message: _unref(messageInfoDialog).message,
          visible: _unref(messageInfoDialog).visible,
          "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_unref(messageInfoDialog).visible) = $event)),
          "show-operator-logins": __props.showOperatorLogins,
          "operators-dictionary": _unref(operatorsDictionary),
          "message-source-type-dictionary": __props.messageSourceTypeDictionary
        }, null, 8, ["message", "visible", "show-operator-logins", "operators-dictionary", "message-source-type-dictionary"]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})